module.exports = __webpack_public_path__ + "static/images/containers/ChallengesPromo/images/rewards.f63dd021.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengesPromo/images/rewards.png
// module id = 2878
// module chunks = 11